<template>
  <div class="col s12 m12 l12">
    <md-modal id="initGame">
      <h4 style="text-align: center">{{ $t("invites.initgame") }}</h4>
      <div class="col s12 m12 l12" style="text-align: center">
        <h1>{{ counterInitGame }}</h1>
      </div>
    </md-modal>
    <md-modal bottom id="invitesGame" class="modal-fixed-footer">
      <p class="flat-text-header">{{ $t("invites.numIn") }} {{ invitesGame.length }}</p>
      <!-- <div class="row s12 m12 l12">
        <div  class="col s6 m6 l6">
          <a class="md-button waves-effect waves-light btn purple darken-4" @click="pcGameInit">
            <i class="material-icons left">play_arrow</i>{{ $t("invites.vspc") }}
          </a>
        </div>
        <div class="row s6 m6 l6" >
         <a class="md-button waves-effect waves-light btn purple darken-4 right" @click="pcGameAnalisis">
            <i class="material-icons left">class</i>{{ $t("invites.vsanalisis") }}
          </a> --
        </div>
      </div> -->
      <md-collection class="row s6 m6 l6">
        <md-collection-item  class="s6 m6 l6" v-for="invite in invitesGame"> 
          
          <!-- <span class="chip">
            {{ invite.u1 }} !--<img style="height: 20px;"
                                 src="../../../static/images/pieces/merida/wP.svg"
                                 alt="">-- VS !--<img style="height: 20px;"
                                                 src="../../../static/images/pieces/merida/bP.svg"
                                                 alt="">-- {{ invite.u2 }} (ELO adversario: {{invite.elo}})
          </span>-->
          <span class="chip">
            <img style="" src="../../assets/50x50defaultAvatar.png" alt="" class="circle">
            <b>{{ invite.u1 }}</b> vs <b>{{ invite.u2 }}</b>
          </span>
          ELO: {{invite.elo}} //     
          Tiempo: {{ invite.time }} + {{ invite.incremento }} minutos {{[invite.event === 'confirmGame'? 'confirmando Iniciar ...': '']}} //
          Creado: {{ invite.created | moment ('DD/MM/YYYY hh:mm:ss') }}
          <div class="secondary-content right">
          <a class="md-button waves-effect waves-light btn purple darken-4" @click="InviteGameActionClick(invite)"><!--<i class="material-icons">play_circle_filled</i>-->Aceptar</a>
          <a class="md-button waves-effect waves-light btn red darken-4" @click="deleteInvite(invite)"><!--<i class="material-icons">delete</i>-->{{ $t("puzzles.create.delete") }}</a>
          </div>
        </md-collection-item>
      </md-collection>
    </md-modal>
    <md-modal id="invitePCGame" class="modal-fixed-footer">
      <h4 style="text-align: center">HUMANO VS PC</h4>
      <div class="col s12 m12 l12">
        <div class="col s6 m4 l4">
          <p class="flat-text-header hello">Color</p>
          <md-radio-group group="color" class="col s6">
            <md-radio :value.sync="newboard.color" radio-value="w" class="with-gap">
              {{ $t("home.createPart.white") }}
            </md-radio>
            <md-radio :value.sync="newboard.color" radio-value="b" class="with-gap">
              {{ $t("home.createPart.black") }}
            </md-radio>
          </md-radio-group>
        </div>
      </div>
      <span slot="footer">
        <md-button href="#" class="waves-effect waves-light purple darken-4" style="margin-right: 10px;"
                   @click="createdVsPcGame(true)">
          {{ $t("home.createPart.create") }}
        </md-button>

        <md-button href="#" class="waves-effect waves-light purple darken-4" style="margin-right: 10px;"
                   @click="createdVsPcGame(false)">
          {{ $t("home.createPart.cancel") }}
          <md-icon right>cancel</md-icon>
        </md-button>
      </span>
    </md-modal>


    <md-modal id="invitePCAnalisis" class="modal-fixed-footer">
      <h4 style="text-align: center">{{$t("game.createClass")}}</h4>
      <div class="col s12 m12 l12">
        <div class="col s6 m4 l4">
          <md-input name="nameAnalisis" :value.sync="nameAnalisis">
              {{$t("game.nameClass")}}
          </md-input>
          <div class="col s6 m4 l4" v-if="user.role === 'Admin' || user.role === 'Teacher'">
            <p class="flat-text-header hello">{{ $t("home.createPart.publicAnalisis") }}</p>
            <div class="switch">
              <label>
                {{ $t("home.createPart.private") }}
                <input id="idAnalisisPublic" :checked="true" @init="analisisPublicChange" type="checkbox">
                <span class="lever"></span>
                {{ $t("home.createPart.public") }}
              </label>
            </div>
          </div>
          <div class="col s6 m4 l4" v-if="user.role === 'Admin' || user.role === 'Teacher'">
              <p class="flat-text-header hello">{{ $t("home.createPart.typeAnalisis") }}</p>
              <md-switch :value.sync="analisisToAll">
                  <span slot="on">{{ $t("home.createPart.public") }}</span>
                  <span slot="off">{{ $t("home.createPart.private") }}</span>
              </md-switch>
          </div>
          <div class="col s6 m4 l4" v-if="user.role === 'Admin' || user.role === 'Teacher'">
              <p class="flat-text-header hello">{{ $t("home.createPart.typeBroadcast") }}</p>
              <md-switch :value.sync="broadcastToAll">
                  <span slot="on">{{ $t("home.createPart.broadcast") }}</span>
                  <span slot="off">{{ $t("home.createPart.private") }}</span>
              </md-switch>
          </div>
          <br/>
          <br/>      
          <fieldset v-if="chkLesson">
          <legend>Datos de la lección</legend>
          <md-input name="nameCategory" :value.sync="nameCategory" v-if="chkLesson">
              Nombre de la categoría
          </md-input>
          <md-input name="nameLesson" :value.sync="nameLesson" v-if="chkLesson">
              Nombre de la lección
          </md-input>
          <div class="col s12 m4 l4 input-field" >
                    <select :multiple="true" class="" v-on:change="handleSelectChange" style="display:inline;width:100%;height:auto;">
                        <option v-for="club in listaclubs" :selected="isSelected(club.name)">{{ club.name }}</option>
                        <!--<img style="width: 100%;" v-bind:src="imageUrl(club.image)" alt="" @error="imageUrlAlt">-->
                    </select>
                </div>
          </fieldset>
          <!--<p class="flat-text-header hello">Color</p>
          <md-radio-group group="color" class="col s6">
            <md-radio :value.sync="newboard.color" radio-value="w" class="with-gap">
              {{ $t("home.createPart.white") }}
            </md-radio>
            <md-radio :value.sync="newboard.color" radio-value="b" class="with-gap">
              {{ $t("home.createPart.black") }}
            </md-radio>
          </md-radio-group>-->
        </div>
      </div>
      <span slot="footer">
        <div v-if="user.role === 'Admin' || user.role === 'Teacher'">
          <md-switch class="left large" :value.sync="chkLesson">
              <span slot="on"></span>
              <span slot="off"></span>
          </md-switch>
          <h6 class="left">{{ $t('lesson.option') }} </h6>
        </div>
        <md-button href="#" :class="nameAnalisis.length > 0 ? 'waves-effect waves-light purple darken-4' : 'waves-effect waves-light purple darken-4 disabled'" style="margin-right: 10px;"
                   @click="createdVsPcAnalisis(true)">
          {{ $t("home.createPart.create") }}
        </md-button>
        <span slot="footer">
            <md-button class="waves-effect waves-light red darken-4" style="margin-right: 10px;" @click="this.$broadcast('modal::close', 'some', 'invitePCAnalisis')">
              {{ $t("about.close") }}  <md-icon right>cancel</md-icon><!-- {{ $t("home.createPart.create") }}-->
            </md-button>
        </span>

        <!--<md-button href="#" class="waves-effect waves-light purple darken-4" style="margin-right: 10px;"
                   @click="createdVsPcAnalisis(false)">
          {{ $t("home.createPart.cancel") }}
          <md-icon right>cancel</md-icon>
        </md-button>-->
      </span>
    </md-modal>

    <style scoped>

      .confirmInvite {  
        background-color: #658c8c !important;
      }
    </style>
  </div>
</template>

<script>
import Store from '../../services/lstorage'
import UserService from '../../services/user'
import toast from 'vue-material-components'
import ClubService from '../../services/club'
export default {
  name: 'UserInvites',
  props: {
    user: {
    }
  },
  data () {
    return {
      invitesGame: Store.get('invitesGame', []),
      counterInitGame: 3, // 3
      nameAnalisis: 'Análisis',
      nameLesson: '',
      nameCategory: '',
      listaclubs: [],
      clubActual: '',
      clubActual1: '',
      clubActual2: '',
      clubs: '',
      analisisPublic: true,
      analisisToAll: false,
      broadcastToAll: false,
      chkLesson: false,
      newboard: {
        color: 'b',
        time: '3',
        incremento: 0,
        elo: 1500,
        public: 'true',
        broadcast: 'false',
        all: 'false',
        club: ''
      },
      lastCreated: 0
    }
  },
  mixins: [
    toast
  ],
  methods: {
    initGame (game) {
      // window.alert(JSON.stringify(game))
      this.$route.router.go('/')
      /* var boardToStore = 'board1'
      for (var i = 1; i <= 200; i++) {
        if (!Store.get(boardToStore) || !Store.get(boardToStore)._id) {
          break
        } else {
          // window.alert(Store.get(boardToStore)._id)
          boardToStore = 'board' + i
        }
      } */
      // Store.set(boardToStore, game)
      Store.set(game._id, game)
      this.$broadcast('modal::open', 'initGame')
      var setIn = 1
      this.$broadcast('modal::close', 'some', 'invitesGame')
      clearInterval(setIn)
      this.$broadcast('modal::close', 'some', 'initGame')
      this.counterInitGame = 1
      // this.$route.router.go('/game/' + boardToStore)
      this.$route.router.go('/game/' + game._id)
      /* setIn = setInterval(function () {
        if ((this.counterInitGame - 1) === 0) {
          clearInterval(setIn)
          this.$broadcast('modal::close', 'some', 'initGame')
          this.counterInitGame = 1
          this.$route.router.go('/game/' + boardToStore)
        } else {
          this.counterInitGame --
        }
      }.bind(this), 1000)*/
    },
    testUser (next) {
      // window.alert('testUser')
      UserService.testUser(this, {}).then(function (response) {
        UserService.setUser(response.data)
        next()
      }, function (response) {
        this.error = response.data
      })
    },
    clone (obj) {
      var dupe = (obj instanceof Array) ? [] : {}
      for (var property in obj) {
        if (typeof property === 'object') {
          dupe[property] = this.clone(obj[property])
        } else {
          dupe[property] = obj[property]
        }
      }
      return dupe
    },
    listaDeClubs (tipo) {
      var parms = {
        type: tipo
      }
      var _self = this
      _self.listaclubs = []
      ClubService.get(_self, parms).then(function (response) {
        JSON.parse(response).forEach(function (element) {
          _self.listaclubs.push(element)
        })
      }, function (response) {
        this.error = response.data
      })
    },
    isSelected (clubName) {
      this.clubs = this.clubs.replace(' ,', ',')
      this.clubs = this.clubs.replace(', ', ',')
      var clubList = this.clubs.split(',')
      for (var i = 0; i < clubList.length; i++) {
        if (clubName === clubList[i]) {
          // window.alert(clubName)
          return true
        }
      }
      return false
    },
    handleSelectChange (event) {
      // Accede a las opciones seleccionadas
      // const selectedValue = event.target.value
      const selectedValues = Array.from(event.target.selectedOptions).map(option => option.value)
      // const selectedOptions = Jquery('#opciones').val()
      var clubActual = ''
      var count = selectedValues.length
      var num = 0
      selectedValues.forEach(function (element) {
        clubActual += element
        num++
        if (num < count) {
          clubActual += ','
        }
      })
      this.clubActual = clubActual
    },
    InviteGameActionClick (invite) {
      try {
        this.deleteInvite(invite)
        const inviteForDelete = this.clone(invite)
        // preparar tablero
        // window.alert('InviteGameActionClick1' + JSON.stringify(invite))

        if (invite.u2 === '.ALL.') {
          invite.u2 = UserService.user.username
          invite.recibe = invite.u2
        }
        if (invite.u1 === '.ALL.') {
          invite.u1 = UserService.user.username
          invite.recibe = invite.u1
        }
        var data = {
          c: 'board',
          f: 'confirmGame',
          data: invite
        }
        // window.alert('InviteGameAction')
        // window.alert('InviteGameActionClick2' + JSON.stringify(inviteForDelete))

        if (invite.confirm || invite.vsPc) {
          data.f = 'addBoard'
          this.deleteInvite(inviteForDelete)
        } else {
          this.toast('<span>Esperando confirmacion de usuario</span>', 2000, 'rounded')
        }
        this.$socket.emit('event', data, function (...callbacks) {
          if (callbacks[0]) {
          // window.alert(callbacks[0])
          }
        })
        this.deleteInvite(inviteForDelete)
        // eliminar invitacion del arreglo
        var dataInvite = {
          c: 'board',
          f: 'deleteInviteGame',
          data: inviteForDelete
        }
        this.$socket.emit('event', dataInvite, function (...callbacks) {
          if (callbacks[0]) {
          // window.alert(callbacks[0])
          }
        })
      } catch (err) {
        console.error('<span>' + 'Error (InviteGameActionClick): ' + err + '</span>', 3000)
      }
    },
    analisisPublicChange () {
      if (document.getElementById('idAnalisisPublic')) {
        this.analisisPublic = document.getElementById('idAnalisisPublic').checked
      }
    },
    InviteGameAction (invite) {
      // preparar tablero
      // invite.u2 = UserService.user.username
      // invite.recibe = invite.u2
      var data = {
        c: 'board',
        f: 'confirmGame',
        data: invite
      }
      // window.alert('InviteGameAction')
      // window.alert(JSON.stringify(invite))
      if (invite.confirm || invite.vsPc) {
        data.f = 'addBoard'
        this.deleteInvite(invite)
      } else {
        this.toast('<span>Esperando confirmacion de usuario</span>', 2000, 'rounded')
      }
      this.$socket.emit('event', data, function (...callbacks) {
        if (callbacks[0]) {
          // window.alert(callbacks[0])
          window.swal(callbacks[0])
        }
      })
      this.deleteInvite(invite)
      // eliminar invitacion del arreglo
    },
    deleteInvite (invite) {
      // window.alert('deleteInvite' + JSON.stringify(invite))
      var post = this.invitesGame.indexOf(invite)
      // window.alert(JSON.stringify(post))
      if (post !== -1) {
        this.invitesGame.splice(post, 1)
        Store.set('invitesGame', this.invitesGame)
        // this.toast('<span>Eliminada correctamente</span>', 2000, 'rounded')
      } else {
        for (var i = 0; i < this.invitesGame.length; i++) {
          if (this.invitesGame[i].created === invite.created && this.invitesGame[i].u1 === invite.u1 && this.invitesGame[i].u2 === invite.u2) {
            this.invitesGame.splice(post, 1)
            Store.set('invitesGame', this.invitesGame)
            // this.toast('<span>Eliminada correctamente</span>', 2000, 'rounded')
          }
        }
      }
      var data = {
        c: 'board',
        f: 'refreshInviteGame',
        data: invite
      }
      this.$socket.emit('event', data, function (...callbacks) {
        if (callbacks[0]) {
        // window.alert(callbacks[0])
        }
      })
    },
    pcGameInit () {
      this.$broadcast('modal::open', 'invitePCGame')
      this.$broadcast('modal::close', 'some', 'invitesGame')
    },
    createGame () {
      this.$broadcast('modal::open', 'invitePCAnalisis')
    },
    pcGameAnalisis () {
      this.createdVsPcAnalisis(true)
      // this.$broadcast('modal::open', 'invitePCAnalisis')
      // this.$broadcast('modal::close', 'some', 'invitesGame')
    },
    createdVsPcGame (state) {
      if (!state) {
        this.$broadcast('modal::close', 'some', 'invitePCGame')
        return
      }
      this.$broadcast('modal::close', 'some', 'invitePCGame')
      var invite = {
        u1: '',
        u2: '',
        public: 'false',
        broadcast: 'false',
        all: 'false',
        club: UserService.user.club,
        vsPc: true,
        time: '15',
        incremento: 0,
        elo: 1500,
        confirm: false,
        created: new Date().getTime(),
        color: this.newboard.color
      }
      if (this.newboard.color === 'w') {
        invite.u1 = UserService.user.username
        invite.u2 = 'PC'
        invite.club = UserService.user.club
      } else {
        invite.u2 = UserService.user.username
        invite.u1 = 'PC'
        invite.club = UserService.user.club
      }
      this.InviteGameAction(invite)
    },
    createdVsPcAnalisis (state) {
      if (document.getElementById('idAnalisisPublic')) {
        this.analisisPublic = document.getElementById('idAnalisisPublic').checked
      }
      if (this.chkLesson === true) {
        if (this.nameLesson.length <= 0 || this.nameCategory.length <= 0) {
          // window.alert('Debe rellenar la categoría y lección')
          window.swal('Debe rellenar la categoría y lección', {
            buttons: {
              si: {text: 'Aceptar', value: 'accept'}
            }
          }).then(function (resultParam) {
          })
          return
        }
      }
      if (!state) {
        this.$broadcast('modal::close', 'some', 'invitePCAnalisis')
        return
      }
      this.$broadcast('modal::close', 'some', 'invitePCAnalisis')
      // window.alert(this.broadcastToAll)
      var invite = {
        u1: '',
        u2: '',
        public: this.analisisPublic,
        broadcast: this.broadcastToAll,
        all: this.analisisToAll,
        club: this.chkLesson === true ? this.clubs : UserService.user.club,
        name: this.nameAnalisis,
        lesson: this.nameLesson,
        category: this.nameCategory,
        vsPc: false,
        time: '120',
        elo: 1500,
        incremento: 0,
        confirm: true,
        created: new Date().getTime(),
        color: this.newboard.color
      }
      if (this.newboard.color === 'w') {
        invite.u1 = UserService.user.username
        invite.u2 = UserService.user.username
      } else {
        invite.u2 = UserService.user.username
        invite.u1 = UserService.user.username
      }
      this.InviteGameAction(invite)
    },
    isAdding (invite) {
      this.invitesGame = Store.get('invitesGame', [])
      // this.toast('<span>IsAdding</span>', 25000, 'rounded')
      if (invite !== undefined && this.invitesGame && this.invitesGame.length > 0) {
        // window.alert('isadding')
        // window.alert('isAdding ' + JSON.stringify(this.invitesGame[0]))
        // this.toast('<span>for (var i in this.invitesGame)</span>', 25000, 'rounded')
        for (var i in this.invitesGame) {
          if (this.invitesGame[i].created === invite.created) {
            return true
          }
        }
      }
      return false
    }
  },
  ready () {
    // window.alert(this.user)
    if (this.user !== undefined && (this.user.role === 'Admin' || this.user.role === 'Teacher')) {
      this.analisisPublic = true
    } else {
      this.analisisPublic = false
    }
  },
  created () {
    this.listaDeClubs('Clubs')
    if (this.user !== undefined && (this.user.role === 'Admin' || this.user.role === 'Teacher')) {
      this.analisisPublic = true
    } else {
      this.analisisPublic = false
    }
  },
  watch: {
    clubActual (val, oldVal) {
      this.clubs = val
    }
  },
  events: {
    inviteGame (data) {
      // window.alert('invitegame ' + JSON.stringify(data))
      if (data !== undefined && data.created) {
        /* let invites = Store.get('invitesGame')
        for (var inviteParam in invites) {
          // window.alert('Game ' + JSON.stringify(inviteParam))
          if (invites[inviteParam].time === data.time && invites[inviteParam].incremento === data.incremento) {
            this.InviteGameActionClick(invites[inviteParam])
            this.toast('<span>' + 'Partida en la lista,  iniciando...' + '</span>', 3000)
            // window.alert('Partida en la lista, iniciando...')
            return
          }
        }*/
        this.invitesGame.push(data)
        Store.set('invitesGame', this.invitesGame)
        // this.$broadcast('modal::open', 'invitesGame')
        // this.toast('<span>Tienes una nueva invitacion de juego</span>', 5000, 'rounded')
      }
    },
    confirmGame (data) {
      if (data !== undefined && data.created) {
        this.lastCreated = Store.get('lastCreatedGame')
        if (this.isAdding(data) === false && this.lastCreated !== data.created) {
          // this.toast('<span>this.invitesGame.push</span>', 25000, 'rounded')
          this.lastCreated = data.created
          Store.set('lastCreatedGame', this.lastCreated)
          // window.alert(data.created + ' ' + this.lastCreated)
          this.invitesGame.push(data)
          // window.alert('<span>ConfirmGame</span>')
          this.InviteGameAction(data)
          // this.toast('<span>InviteGameAction</span>', 25000, 'rounded')
        }
        // this.toast('<span>IconfirmGame2</span>', 25000, 'rounded')
        Store.set('invitesGame', this.invitesGame)
        this.$broadcast('modal::open', 'invitesGame')
      }
    },
    deleteInviteGame (data) {
      if (data !== undefined) {
        // window.alert('deleteInviteGame' + JSON.stringify(data))
        delete data.event
        this.deleteInvite(data)
      }
    },
    initGame (data) {
      if (data !== undefined) {
        // inicializando un tablero
        // window.alert('initGame ' + JSON.stringify(data))
        if (data.u1 === UserService.user.username || data.u2 === UserService.user.username) {
          this.initGame(data)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// invites.vue?2e025950